import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { EyeOff, ChevronDown } from "lucide-react";
import { FIELDS_MAP } from "@/lib/permissionsSchema";

export function FieldsPicker({ collection, value, onChange, disabled }) {
  const fields = FIELDS_MAP[collection] || [];
  const hidden = new Set(value || []);
  if (fields.length === 0) return <span className="text-xs text-muted-foreground">—</span>;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" disabled={disabled} className="h-7 text-xs">
          <EyeOff className="w-3 h-3 mr-1.5" />
          {hidden.size > 0 ? `${hidden.size} hidden` : "None hidden"}
          <ChevronDown className="w-3 h-3 ml-1.5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2" align="start">
        <p className="text-[10px] uppercase tracking-[0.16em] text-muted-foreground px-1 pb-1.5">Hide these fields</p>
        <div className="space-y-0.5 max-h-56 overflow-y-auto">
          {fields.map((f) => (
            <label key={f.name} className="flex items-center gap-2 px-1 py-1 rounded hover:bg-muted/60 text-sm cursor-pointer">
              <Checkbox
                checked={hidden.has(f.name)}
                onCheckedChange={(v) => {
                  const next = new Set(hidden);
                  if (v) next.add(f.name); else next.delete(f.name);
                  onChange([...next]);
                }}
              />
              {f.label}
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
